import { render } from "./statusTable.vue?vue&type=template&id=973f7c90&scoped=true"
import script from "./statusTable.vue?vue&type=script&lang=js"
export * from "./statusTable.vue?vue&type=script&lang=js"

import "./statusTable.vue?vue&type=style&index=0&id=973f7c90&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973f7c90"]])

export default __exports__